<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent pb-6">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        Tell us about your
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">Agency</span>.
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left w-full">
        We'll
        use this information to create your agency profile.</p>


    <div class="w-full max-w-4xl flex flex-col gap-y-4 py-6 sm:py-8">
        <div class="grid grid-cols-1 gap-x-6 gap-y-5 sm:gap-y-6 sm:grid-cols-6">

            <div class="sm:col-span-6">
                <label for="agencyNameInput" class="block text-sm/6 font-medium text-primary">Agency name</label>
                <div class="mt-2 grid grid-cols-1">
                    <input #agencyNameInput [formField]="slickAgencyService.agencyForm.agencyName" id="agencyNameInput"
                        type="text" placeholder="Your Agency Name"
                        class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                        <path d="M10 5V3" />
                        <path d="M14 5V3" />
                        <path d="M15 21v-3a3 3 0 0 0-6 0v3" />
                        <path d="M18 3v8" />
                        <path d="M18 5H6" />
                        <path d="M22 11H2" />
                        <path d="M22 9v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9" />
                        <path d="M6 3v8" />
                    </svg>

                </div>
                @if (slickAgencyService.agencyForm.agencyName().touched() &&
                slickAgencyService.agencyForm.agencyName().invalid()) {
                <ul class="error-list">
                    @for (error of slickAgencyService.agencyForm.agencyName().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>

            <div class="sm:col-span-6">
                <label for="agencyNameInput" class="block text-sm/6 font-medium text-primary">Agency website</label>
                <div class="mt-2 flex">
                    <div
                        class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                        https://</div>
                    <input [formField]="slickAgencyService.agencyForm.agencyWebsite" #agencyWebsiteInput
                        id="agencyWebsiteInput" type="text" placeholder="www.example.com" autocomplete="url"
                        class="input-url text-primary text-base rounded-r-md flex-1" />
                </div>
                @if (slickAgencyService.agencyForm.agencyWebsite().touched() &&
                slickAgencyService.agencyForm.agencyWebsite().invalid()) {
                <ul class="error-list">
                    @for (error of slickAgencyService.agencyForm.agencyWebsite().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>

            <div class="sm:col-span-6">
                <label for="agencyCurrencySelect" class="block text-sm/6 font-medium text-primary">Operating
                    currency</label>
                <el-select id="agencyCurrencySelect" name="currencyCode"
                    [value]="slickAgencyService.agencyFormModel().currencyCode" class="mt-2 block">
                    <button type="button"
                        class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:focus-visible:outline-primary">
                        <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">{{ selectedCurrencyLabel()
                            }}</el-selectedcontent>
                        <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                            class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                            <path
                                d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                clip-rule="evenodd" fill-rule="evenodd" />
                        </svg>
                    </button>

                    <el-options anchor="bottom start" popover
                        class="max-h-60 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                        @for (currency of currencyOptions; track currency.value) {
                        <el-option [value]="currency.value" (click)="onCurrencySelected(currency.value)"
                            class="group/option relative block cursor-default py-2 pr-4 pl-8 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                            <span class="block truncate font-normal group-aria-selected/option:font-semibold">
                                {{ currency.flag }} {{ currency.label }}</span>
                            <span
                                class="absolute inset-y-0 left-0 flex items-center pl-1.5 text-accent group-not-aria-selected/option:hidden group-focus/option:text-white in-[el-selectedcontent]:hidden">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5">
                                    <path
                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </span>
                        </el-option>
                        }
                    </el-options>
                </el-select>
            </div>

            <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:col-span-full">
                <div></div>

                <button type="button" id="continue-button" (click)="saveAgencyDetails()" [disabled]="!canSubmit()"
                    class="w-full sm:w-auto sm:min-w-40 text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold touch-manipulation order-1 sm:order-2 disabled:opacity-40 disabled:cursor-not-allowed">

                    <p class="block">Continue</p>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 shrink-0">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>

                </button>
            </div>

        </div>
    </div>
</div>